export const formatTaktTime = (taktTime: string): string => {
  if (!taktTime) return '00:00'

  const parts = taktTime.split(':')
  if (parts.length >= 2) {
    const hours = parseInt(parts[0])
    const minutes = parts[1]
    const seconds = parts[2] || '00'

    return hours > 0 ? `${taktTime}` : `${minutes}:${seconds}`
  }

  return '00:00'
}

export const formatDurationText = (totalMinutes: number): string => {
  if (!totalMinutes || totalMinutes <= 0) return 'N/A'
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  if (hours > 0 && minutes > 0) return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} min`
  if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''}`
  return `${minutes} min`
}
